<template>
  <Layout class="layout--topbar highlights-layout">
    <HeaderRoot title="Highlights" />
    <div class="layout__wrapper">
      <section class="filter-box filter-box--highlights highlights--full-page">
        <div class="container">
          <div class="highlights__header">
            <div
              class="highlights__title-box highlights__title-box--hide-mobile"
            >
              <h1
                class="highlights__title"
                @click="_unitTestsThrowError4Sentry"
              >
                Highlights, notes and bookmarks
              </h1>
            </div>
            <ExportHighlightsButton />
          </div>
        </div>
      </section>

      <vWait for="Loading Books">
        <template v-slot:waiting>
          <loading-spinner />
        </template>
      </vWait>

      <HighlightsByBook />
    </div>
  </Layout>
</template>

<script setup lang="ts">
import vWait from 'vue-wait/src/components/v-wait.vue'
import HighlightsByBook from '@/app/components/book/highlights/HighlightsByBook.vue'
import ExportHighlightsButton from '@/app/components/book/highlights/ExportHighlightsButton.vue'
import HeaderRoot from '@/app/components/header/Root.vue'

import Layout from '@/app/components/Layout.vue' // @ is an alias to /src
import LoadingSpinner from '@/components/ui/LoadingSpinner.vue'

// Function for unit-testing purposes only (works only in unit-tests).
// Checking that unhandled errors are caught by Sentry.
function _unitTestsThrowError4Sentry(): void {
  if ((window as any)['__UNIT_TESTING']) {
    throw new Error('Unhandled error should be caught by Sentry')
  }
}
</script>
